import { Card, CardHeader, Typography, Button } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useSelector } from "react-redux";
import { setDialog } from "../../../../../app/slices/operationTransferSlice";
import OperationTransferForm from "../../from";
import { BiTransferAlt } from "react-icons/bi";
import Permission from "../../../../../components/userPermission/userPermission";

const OperationTransferHeader = () => {
  const _OperationTransfer = useSelector(
    (state) => state.operationTransfer.operationTransfer
  );
  const dispatch = useDispatch();

  return (
    <Card>
      <CardHeader
        title={
          <Typography variant="h4" component="div">
            عمليات التحويل
          </Typography>
        }
        avatar={<BiTransferAlt size={20} />}
        action={
          <Permission permission="operation_transfer_edit">
            <Button
              variant="contained"
              color="primary"
              size="medium"
              startIcon={<IoIosAddCircleOutline />}
              onClick={() => dispatch(setDialog())}
            >
              إضافة
            </Button>
          </Permission>
        }
      />
      {_OperationTransfer.dialog && <OperationTransferForm />}
    </Card>
  );
};

export default OperationTransferHeader;
